module.exports = __webpack_public_path__ + "img/slide_3.c03bcf05.jpg";